import React, { useEffect } from "react";
import * as bootstrap from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import FullVideo from "./images/Full_Size_Video.mov";
import ReactGA from "react-ga";
const TRACKING_ID = "UA-5168202-7";
ReactGA.initialize(TRACKING_ID);

export const FullModal = (props) => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  return (
    <div
      className="modal show"
      style={{ display: "block", position: "initial" }}
    >
      <bootstrap.Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <bootstrap.Modal.Header closeButton>
          <bootstrap.Modal.Title id="contained-modal-title-vcenter">
            <p className="text-center lead">{t("layout.videoFull")}</p>
          </bootstrap.Modal.Title>
        </bootstrap.Modal.Header>
        <bootstrap.Modal.Body>
          <bootstrap.Row>
            <bootstrap.Col></bootstrap.Col>
            <bootstrap.Col>
              <video className="embed-responsive-item" height={400} controls>
                <source src={FullVideo} />
              </video>
            </bootstrap.Col>
            <bootstrap.Col></bootstrap.Col>
          </bootstrap.Row>
        </bootstrap.Modal.Body>
        <bootstrap.Modal.Footer>
          <bootstrap.Button onClick={props.onHide}>Close</bootstrap.Button>
        </bootstrap.Modal.Footer>
      </bootstrap.Modal>
    </div>
  );
};
